/* rhoneprints: a little trail of 1s and 0s behind the cursor (desktop mouse only) */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var c = document.createElement('canvas');
  c.setAttribute('aria-hidden', 'true');
  c.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:9997';
  document.body.appendChild(c);
  var ctx = c.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  function size() {
    c.width = window.innerWidth * dpr;
    c.height = window.innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  size();
  window.addEventListener('resize', size);

  var COLORS = ['#22e6ff', '#ff2fd0', '#f2efff'];
  var ps = [];
  var lx = -99, ly = -99, last = 0, run = false;

  function tick(now) {
    var dt = Math.min(now - last, 50);
    last = now;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    for (var i = ps.length - 1; i >= 0; i--) {
      var p = ps[i];
      p.t += dt;
      if (p.t >= p.life) { ps.splice(i, 1); continue; }
      p.x += p.vx * dt * 0.06;
      p.y += p.vy * dt * 0.06;
      if (Math.random() < 0.04) p.ch = p.ch === '0' ? '1' : '0';
      ctx.globalAlpha = Math.max(0, 1 - p.t / p.life) * 0.9;
      ctx.fillStyle = p.col;
      ctx.font = p.s + 'px "Space Mono", monospace';
      ctx.fillText(p.ch, p.x, p.y);
    }
    ctx.globalAlpha = 1;
    if (ps.length) { requestAnimationFrame(tick); }
    else { run = false; ctx.clearRect(0, 0, window.innerWidth, window.innerHeight); }
  }

  window.addEventListener('mousemove', function (e) {
    var dx = e.clientX - lx, dy = e.clientY - ly;
    if (dx * dx + dy * dy < 196) return;
    lx = e.clientX; ly = e.clientY;
    ps.push({
      x: e.clientX + (Math.random() - 0.5) * 12,
      y: e.clientY + (Math.random() - 0.5) * 12,
      vx: (Math.random() - 0.5) * 0.8,
      vy: 0.3 + Math.random() * 0.8,
      t: 0,
      life: 700 + Math.random() * 700,
      ch: Math.random() < 0.5 ? '0' : '1',
      col: COLORS[Math.floor(Math.random() * COLORS.length)],
      s: 12 + Math.floor(Math.random() * 9)
    });
    if (ps.length > 140) ps.shift();
    if (!run) { run = true; last = performance.now(); requestAnimationFrame(tick); }
  }, { passive: true });
})();
